import React, { useContext, useState } from "react";
import { IMainContext, MainProviderProps } from "./interface";

const MainContext = React.createContext<IMainContext>({
  activeMenuGroup: "",
  setActiveMenuGroup: () => {},
});

const MainProvider: React.FC<MainProviderProps> = ({ children }) => {
  const [activeMenuGroup, setActiveMenuGroup] = useState("");

  return (
    <MainContext.Provider value={{ activeMenuGroup, setActiveMenuGroup }}>
      {children}
    </MainContext.Provider>
  );
};

export default MainContext;

const useMain = () => useContext(MainContext);

export { MainProvider, useMain };
